// extracted by mini-css-extract-plugin
export default {"recos":"N5-z","productCardOverride":"O5-z","rowHasBadge":"P5-z"};